module.exports = __webpack_public_path__ + "img/puertoRico.363d8bfa.jpg";